export default __webpack_public_path__ + "static/media/Todo.c1ac6bd2.png";